import { useQuery } from "react-query";

import { getData } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { IPaginatedResponse } from "../interfaces/response";
import { IAuditTrailSearchParams } from "../interfaces/auditTrail";

interface IQuery extends IAuditTrailSearchParams {
  page: number;
  size: number;
}

type TAuditTrail = {
  action_date: string;
  action_time: string;
  audit_trail_type_id: number;
  audit_type: string;
  client_ip_address: string;
  current_data: string;
  id: number;
  object_id: number;
  object_reference_no: string;
  previous_data: string;
  user_id: number;
  username: string;
};

const getAuditTrail = async ({
  audit_type_id,
  start_date,
  end_date,
  page,
  size,
  entity_name,
  rc_number,
  bvn,
  user_name,
}: IQuery) => {
  let queryParams = `page=${page}&pageSize=${size}`;
  if (audit_type_id) {
    queryParams = `${queryParams}&audit_type_id=${audit_type_id}`;
  }
  if (start_date) {
    queryParams = `${queryParams}&start_date=${start_date}`;
  }
  if (end_date) {
    queryParams = `${queryParams}&end_date=${end_date}`;
  }
  if (rc_number) {
    queryParams = `${queryParams}&rc_number=${rc_number}`;
  }
  if (entity_name) {
    queryParams = `${queryParams}&entity_name=${entity_name}`;
  }
  if (audit_type_id) {
    queryParams = `${queryParams}&audit_type_id=${audit_type_id}`;
  }
  if (bvn) {
    queryParams = `${queryParams}&bvn=${bvn}`;
  }
  if (user_name) {
    queryParams = `${queryParams}&user_name=${user_name}`;
  }
  const { data } = await getData(
    `${ajaxEndpoints.PRODUCT_AUDITS}?${queryParams}`,
  );
  return data;
};

export default function useAuditTrail({
  audit_type_id,
  start_date,
  end_date,
  page,
  size,
  entity_name,
  bvn,
  rc_number,
  user_name,
}: IQuery) {
  return useQuery<IPaginatedResponse<TAuditTrail[]>>(
    [
      {
        audit_type_id,
        start_date,
        end_date,
        page,
        size,
        entity_name,
        user_name,
        bvn,
        rc_number,
      },
      "getAuditTrail",
    ],
    getAuditTrail,
    {
      refetchOnWindowFocus: false,
    },
  );
}
